module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title-2"
  }, [_c('span', [_vm._v("A NIGHT AT THE OPERA")])]), _vm._v(" "), _c('p', {
    staticClass: "left-1"
  }, [_vm._v("Rheingold! Rarest gold!")]), _vm._v(" "), _c('p', {
    staticClass: "left-1"
  }, [_vm._v("O, might only thy purest magic waken again in the waves!")]), _vm._v(" "), _c('p', {
    staticClass: "left-1"
  }, [_vm._v("What is of value can only dwell in the waters!")]), _vm._v(" "), _c('p', {
    staticClass: "left-1"
  }, [_vm._v("Base and vile are those enthroned above!")]), _vm._v(" "), _c('p', {
    staticClass: "right1-1"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("The Lament of the Rhein Maidens")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "right1-1"
  }, [_c('span', [_c('i', [_vm._v("Richard Wagner")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "right1-1"
  }, [_c('span', [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAS RHEINGOLD")]), _vm._v(", Act I")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a99baa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter002.vue
// module id = 81
// module chunks = 0